import cx from "classnames";
import React from "react";

import AvatarImgWithOverlay from "@/mk2/apps/blogs/components/AvatarImgWithOverlay";
import { blogsProfileUrl } from "@/mk2/apps/blogs/urls";
import { Btn, BtnType } from "@/mk2/components/Btn";
import { Link } from "@/mk2/components/Link";
import { url } from "@/mk2/helpers/urls";
import { LoadingState } from "@/mk2/reducers/loadingState";
import { UserEntity } from "@/mk2/schemas";
import { SHOW_ALL_FRIENDS } from "@/mk/autogenerated/translations/AvatarImgGrid.93b17760b86191382e0a4251640c04fe";

import styles from "./AvatarImgGrid.mscss";

interface OwnProps {
    id?: string;
    countAll: number;
    expanded: boolean;
    hasMore: boolean;
    header: string;
    isMobile: boolean;
    loadingState: LoadingState;
    maxLinesCountIfCollapsed: number;
    users: UserEntity[];

    onExpand();
}

type Props = OwnProps;

const AVATAR_SIZE: { [n: number]: 36 | 50 } = {
    0: 36, // desktop
    1: 50, // mobile
};
const AVATAR_MARGIN: { [n: number]: 16 | 23 } = {
    0: 16, // desktop
    1: 23, // mobile
};

export default class AvatarImgGrid extends React.Component<Props> {
    private instanceRef = React.createRef<HTMLDivElement>();

    public render() {
        const {
            countAll,
            expanded,
            hasMore,
            header,
            isMobile,
            maxLinesCountIfCollapsed,
            onExpand,
            users,
            id,
        } = this.props;

        let someAvatarsAreHidden = false;
        const divWidth = this?.instanceRef?.current?.offsetWidth;
        const mobile = isMobile ? 1 : 0;
        if (divWidth) {
            const itemsPerLine = Math.floor(
                divWidth / (AVATAR_SIZE[mobile] + AVATAR_MARGIN[mobile]),
            );
            if (!expanded && !hasMore) {
                someAvatarsAreHidden = users.length > itemsPerLine * maxLinesCountIfCollapsed;
            }
        }

        return (
            <div className={styles.AvatarImgGrid} id={id}>
                <div ref={this.instanceRef} className={styles.AvatarImgGrid__wrap}>
                    <h2>
                        {header} <span>({countAll})</span>
                    </h2>
                    <div
                        className={cx(
                            styles.AvatarImgGrid__users,
                            !expanded && styles["AvatarImgGrid__users--collapsed"],
                        )}
                    >
                        {users.map((user, index) => {
                            return (
                                <div className={styles.AvatarImgGrid__users__user} key={user.id}>
                                    <Link to={url(blogsProfileUrl, { username: user.username })}>
                                        <AvatarImgWithOverlay
                                            user={user}
                                            size={AVATAR_SIZE[mobile]}
                                        />
                                        {isMobile && (
                                            <div
                                                className={
                                                    styles.AvatarImgGrid__users__user__username
                                                }
                                            >
                                                {user.username}
                                            </div>
                                        )}
                                    </Link>
                                </div>
                            );
                        })}
                    </div>
                    {!expanded && (hasMore || someAvatarsAreHidden) && (
                        <div className={styles.AvatarImgGrid__more}>
                            <Btn
                                label={SHOW_ALL_FRIENDS}
                                type={BtnType.Link}
                                sidePadding={0}
                                onClick={onExpand}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
